import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { Dropdown, Modal } from 'bootstrap';
import uuid from 'react-uuid';
import { toast } from "react-toastify";
import moment from 'moment';
import TapIcon from '../../../services/TapIcon';
import HttpAPICall from '../../../services/HttpAPICall';
import { EMP_WORKLOG_URL, HRM_API_BASE_URL_2, ORG_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import Loader from '../../../components/ui/Loader/Loader';
import AdditionalAttributeForm from '../../includes/ui/AdditionalAttributeForm';
import Status from '../../../components/ui/Status';
import TapSelect from '../../../components/ui/TapSelect';
import DatePicker from "react-datepicker";
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import InputTicketSearch from '../../includes/ui/InputTicketSearch';
import InputWorkstationSearch from '../../includes/ui/InputWorkstationSearch';
import DateService from '../../../services/DateService';
import api from '../../../services/api';

const WorkLogModal = forwardRef((props, ref) => {
    let initFormData = {
        loading                 :   false,
        submitting              :   false,
        work_log_type           :   null,
        start_time              :   null,
        end_time                :   null,
        log_seconds             :   0,
        total_hour              :   null,
        full_shift              :   'N',
        shift_seconds           :   0,
        shift_start             :   null,
        shift_end               :   null,
        asset_id                :   null,
        ticket_id               :   null,
        workstation_id          :   null,
        notes                   :   '',
        searchedAsset           :   null,
        searchedTicket          :   null,
        searchedWorkstation     :   null,
        attendance_id           :   null,
        attendance_date         :   null, 
        id                      :   null,
        isEditMode              :   false,
        showDocument            :   false,
        name                :   '',
        number              :   '',
        photo               :   null,
        doc_other               :   'N'
    };

    const permissions                               =   useSelector(state => state.app.acl_info && state.app.acl_info.permissions ? state.app.acl_info.permissions : []);
    const access_token                              =   useSelector(state => state.auth.access_token);
    const setting                                   =   useSelector(state => state.app.setting)
    const modalElem                                 =   useRef(null); 
    const modal                                     =   useRef(null);
    const isInitialDataLoaded                       =   useRef(false);
    const [modalId]                                 =   useState(uuid());
    const [workLogFormData, setWorkLogFormData]     =   useState(null);
    const [employeeData, setEmployeeData]           =   useState(null);
    const [selectedTag, setSelectedTag]             =   useState(null);
    const [formId]                                  =   useState(uuid());
    const [formData, setFormData]                   =   useState({ ...initFormData });
    const [config, setConfig]                       =   useState({
        employee_workflow_enable_tag_asset: 'N',
        employee_workflow_enable_tag_ticket: 'N',
        employee_workflow_enable_tag_workstation: 'N',
    });
    
    const [documentTypes, setDocumentTypes] = useState([]);
    const [worklogDocuments, setWorklogDocuments] = useState([]);
    const [loadingDocuments, setLoadingDocuments] = useState(false);

    let formDataUrl             =   EMP_WORKLOG_URL + '/form_data';
    let formDataSaveUrl         =   EMP_WORKLOG_URL + '/add';
    let formDataUpdateUrl       =   EMP_WORKLOG_URL + '/edit';
    const iscDocTypeUrl = `${ORG_API_BASE_URL_2}/setting/isc_doc_types`;

    const tagOptions = [
        config.employee_workflow_enable_tag_asset === 'Y' && { key: "asset", label: "Asset" },
        config.employee_workflow_enable_tag_workstation === 'Y' && { key: "workstation", label: "Workstation" },
    ].filter(Boolean);

    useImperativeHandle(ref, () => ({
        worklogModalInit: (employeeInfo, attendanceData) => {
            setFormData({ ...initFormData });
            setEmployeeData(employeeInfo || "");
            setWorklogDocuments([]);

            const checkInMoment = attendanceData?.check_in ? moment(attendanceData.check_in) : null;
            const checkOutMoment = attendanceData?.check_out ? moment(attendanceData.check_out) : null;

            const shiftStart = checkInMoment ? checkInMoment.toDate() : null;
            const shiftEnd = checkOutMoment ? checkOutMoment.toDate() : null;

            let shiftSeconds = 0;
            if (checkInMoment && checkOutMoment) {
                shiftSeconds = moment.duration(checkOutMoment.diff(checkInMoment)).asSeconds();
            }

            
            setFormData(prev => ({
                ...prev,
                attendance_id: attendanceData?.id || null,
                shift_seconds: shiftSeconds,
                shift_start: shiftStart,
                shift_end: shiftEnd,
                attendance_date: attendanceData?.date || "",
                start_time: null,
                end_time: null,
                log_seconds: 0,
                full_shift: 'N',
                isEditMode: false,
                showDocument: false,
                name: '',
                number: '',
                photo: null,
                doc_other: 'N'
            }));

            setConfig(setting);
            openModalHandler();
        },
        worklogEditModalInit: (employeeInfo, data) => {
            setFormData({ ...initFormData, loading: true });
            setEmployeeData(employeeInfo || "");
            setConfig(setting);
            HttpAPICall.withAthorization(
                "GET",`${EMP_WORKLOG_URL}/detail/${data.id}`, access_token,{}, {},
                (resp) => {
                     const detailedData = resp?.data || {};
                    const documents = detailedData?.docs || [];
                    setWorklogDocuments(documents);
                     const attendanceId = detailedData?.attendance_id
                    let matchingAttendance = null;
                    if (employeeInfo?.attendence && Array.isArray(employeeInfo.attendence)) {
                        matchingAttendance = employeeInfo.attendence.find(
                            attendance => attendance.id === attendanceId
                        );
                    }
                    const checkInTime = matchingAttendance?.check_in ||
                       "-"

                    const checkOutTime = matchingAttendance?.check_out ||
                       "-"

                    const attendanceDate = matchingAttendance?.date ||
                        "-"

                    populateEditFormData(detailedData, {
                        ...data,
                        check_in: checkInTime,
                        check_out: checkOutTime,
                        date: attendanceDate,
                        attendance_id: attendanceId
                    });
                    setFormData(prev => ({
                        ...prev,
                        loading: false
                    }));
                }
            ).catch(() => {
                setFormData(prev => ({
                    ...prev,
                    loading: false
                }));
            });
            openModalHandler(); 
        },
    }));


    const handleFileChange = (e) => {
        let file = e.target.files[0];
        setFormData(prev => ({ ...prev, photo: file }));
    };


    const populateEditFormData = (worklogData, attendanceData) => {
        const startTimeMoment = worklogData.start_time ? moment(worklogData.start_time) : null;
        const endTimeMoment = worklogData.end_time ? moment(worklogData.end_time) : null;

        let logSeconds = 0;
        if (startTimeMoment && endTimeMoment) {
            logSeconds = moment.duration(endTimeMoment.diff(startTimeMoment)).asSeconds();
        }

        const checkInMoment =
            attendanceData?.check_in
                ? moment(attendanceData.check_in)
                : worklogData?.attendance?.check_in
                    ? moment(worklogData.attendance.check_in)
                    : null;

        const checkOutMoment =
            attendanceData?.check_out
                ? moment(attendanceData.check_out)
                : worklogData?.attendance?.check_out
                    ? moment(worklogData.attendance.check_out)
                    : null;

        const shiftStart = checkInMoment?.toDate() || null;
        const shiftEnd = checkOutMoment?.toDate() || null;

        const shiftSeconds =
            checkInMoment && checkOutMoment
                ? moment.duration(checkOutMoment.diff(checkInMoment)).asSeconds()
                : 0;
        setFormData(prev => ({
            ...prev,
            id: worklogData?.id,
            isEditMode: true,
            work_log_type: worklogData?.work_log_type ? {
                value: worklogData?.work_log_type?.id,
                label: worklogData?.work_log_type?.name
            } : null,
            start_time: startTimeMoment ? startTimeMoment.toDate() : null,
            end_time: endTimeMoment ? endTimeMoment.toDate() : null,
            log_seconds: logSeconds ,
            notes: worklogData?.notes || '',
            
            asset_id: worklogData?.asset?.asset_id || null,
            searchedAsset: worklogData?.asset ? {
                value: worklogData?.asset?.asset_id,
                label: worklogData?.asset?.name || "",
                display_label: `${worklogData?.asset.name} (${worklogData?.asset?.asset_code})`
            } : null,
            
            ticket_id: worklogData?.ticket?.activity_id || null,
            searchedTicket: worklogData?.ticket ? {
                value: worklogData?.ticket?.id,
                label: `${worklogData?.ticket?.activity_id} : ${worklogData?.ticket?.header}` 
            } : null,
            
            workstation_id: worklogData?.workstation?.id || null,
            searchedWorkstation: worklogData?.workstation ? {
                value: worklogData?.workstation.id,
                label: worklogData?.workstation.name || ""
            } : null,
            attendance_id: worklogData?.attendance_id || null,
            shift_seconds: shiftSeconds,
            shift_start: shiftStart,
            shift_end: shiftEnd,
            attendance_date:  worklogData?.date || "",
            full_shift: worklogData?.full_shift || 'N'
        }));

        if (worklogData.additional_attr && worklogData.additional_attr.length > 0) {
            const additionalData = {};
            worklogData.additional_attr.forEach(attr => {
                const fieldName = "additional_attributes_" + attr.key;
                additionalData[fieldName] = attr.value || "";
            });

            setFormData(prev => ({
                ...prev,
                ...additionalData
            }));
        }
        if (worklogData?.asset?.asset_id) {
            setSelectedTag("asset");
        }
        else if (worklogData?.workstation?.id) {
            setSelectedTag("workstation");
        }
    };

    const openModalHandler = () => {

    if (!isInitialDataLoaded.current) {
        isInitialDataLoaded.current = true;
            formDataInit()
    
    }

    modalOpen();
};

    const modalOpen = () => {
        if (modal.current) { modal.current.show(); }
    };

    const modalClose = () => {
        if (modal.current) { modal.current.hide(); }
        setFormData({ ...initFormData });
        setWorklogDocuments([]);
    };

    const formDataInit = () => {
        setFormData(pd => ({ ...pd, loading: true }));
         HttpAPICall.withAthorization('GET', formDataUrl, access_token, {}, {}, (resp) => {
            setWorkLogFormData(resp.data);
             setDocumentTypes(
                 resp?.data?.doc_types?.map(item => ({
                     label: item,
                     value: item
                 }))
             );
            
        }).catch(error => {
            toast.error("Failed to load form data", { position: toast.POSITION.TOP_RIGHT });
        }).finally(() => {
            setFormData(pd => ({ ...pd, loading: false }));
        })
    };

    useEffect(() => {
        modalElem.current = document.getElementById(modalId);
        modal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });

        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        };
    }, [modalId]);

    const calculateDuration = (startTime, endTime) => {
        if (startTime && endTime) {
            const start = moment(startTime);
            const end = moment(endTime);
            if (end.isBefore(start)) {
                end.add(1, 'day');
            }
            
            return moment.duration(end.diff(start)).asSeconds();
        }
        return 0;
    };

    const handleFullShiftToggle = (e) => {
        const checked = e.target.checked;

        setFormData(prev => {
            if (checked && prev.shift_start && prev.shift_end) {
                return {
                    ...prev,
                    full_shift: 'Y',
                    start_time: new Date(prev.shift_start),
                    end_time: new Date(prev.shift_end),
                    log_seconds: prev.shift_seconds
                };
            }

            return {
                ...prev,
                full_shift: 'N',
                start_time: null,
                end_time: null,
                log_seconds: 0
            };
        });
    };
    const ensureDateWithinShift = (date, shiftStart) => {
        if (!date && shiftStart) {
            return new Date(shiftStart);
        }
        return date;
    };
    const handleStartTimeChange = (value) => {
        setFormData(prev => {

            const safeDate = ensureDateWithinShift(value, prev.shift_start);

             const durationSeconds = calculateDuration(
            safeDate,
            prev.end_time
        );

            return {
                ...prev,
                start_time: safeDate,
                log_seconds: durationSeconds,
                full_shift: 'N'
            };
        });
    };

    const handleEndTimeChange = (value) => {
        setFormData(prev => {

            const safeDate = ensureDateWithinShift(value, prev.shift_start);

             const durationSeconds = calculateDuration(
            prev.start_time,
            safeDate
        );

                    return {
                ...prev,
                end_time: safeDate,
                log_seconds: durationSeconds,
                full_shift: 'N'
            };
        });
    };
    const handleAttributeChange = (value, attributeName) => {
        setFormData(prev => ({
            ...prev,
            [attributeName]: value
        }));
    };

    const validateForm = () => {

        if (!formData.start_time) {
            toast.error("Please select Start Time", { position: toast.POSITION.TOP_RIGHT });
            return false;
        }

        if (!formData.end_time) {
            toast.error("Please select End Time", { position: toast.POSITION.TOP_RIGHT });
            return false;
        }

        if (formData.log_seconds <= 0) {
            toast.error("End time must be after start time", { position: toast.POSITION.TOP_RIGHT });
            return false;
        }

        if (formData.showDocument) {
            if (!formData.name) {
                toast.error("Please select/enter document type", { position: toast.POSITION.TOP_RIGHT });
                return false;
            }
            if (!formData.photo) {
                toast.error("Please select a document", { position: toast.POSITION.TOP_RIGHT });
                return false;
            }
        }

        return true;
    };

    const submitEventHandler = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setFormData(pd => ({ ...pd, submitting: true }));

        const startDateTime = moment(formData.start_time);
        let endDateTime = moment(formData.end_time);

        if (endDateTime.isBefore(startDateTime)) {
            endDateTime.add(1, 'day');
        }

        const apiUrl = formData.isEditMode
            ? formDataUpdateUrl
            : formDataSaveUrl;

        const method = formData.isEditMode ? "PUT" : "POST";

        let requestConfig = {};
        if (method === "PUT") {
            const additional_attributes = {};

            if (workLogFormData?.additional_attributes?.length > 0) {
                workLogFormData.additional_attributes.forEach((attr) => {
                    const key = attr.key;
                    additional_attributes[key] =
                        formData[`additional_attributes_${key}`] || "";
                });
            }
            const payload = {
                id: formData.id,
                employee_id: employeeData?.employee?.enc_id || "",
                work_log_type_id: formData.work_log_type?.value,
                attendance_id: formData.attendance_id,
                start_time: startDateTime.format("YYYY-MM-DD HH:mm:ss"),
                end_time: endDateTime.format("YYYY-MM-DD HH:mm:ss"),
                log_seconds: formData?.log_seconds,
                full_shift: formData?.full_shift,
                notes: formData.notes || "",
                employee_workflow_enable_tag_asset:
                    config?.employee_workflow_enable_tag_asset,
                employee_workflow_enable_tag_ticket:
                    config?.employee_workflow_enable_tag_ticket,
                employee_workflow_enable_tag_workstation:
                    config?.employee_workflow_enable_tag_workstation,
                additional_attributes
            };

            if (
                config?.employee_workflow_enable_tag_asset === "Y" &&
                formData?.asset_id
            ) {
                payload.asset_id = formData?.asset_id;
            }

            if (config.employee_workflow_enable_tag_ticket === "Y" && formData.ticket_id) {
                payload.ticket_id = formData.ticket_id;
            }

            if (
                config.employee_workflow_enable_tag_workstation === "Y" &&
                formData.workstation_id
            ) {
                payload.workstation_id = formData?.workstation_id;
            }


            requestConfig = {
                method: "PUT",
                url: apiUrl,
                data: payload,
                headers: {
                    Authorization: `Bearer ${access_token}`,
                    "Content-Type": "application/json",
                },
            };
        }

        else {
            const formDataObj = new FormData();

            formDataObj.append("employee_id", employeeData?.employee?.enc_id || "");
            formDataObj.append("work_log_type_id", formData?.work_log_type?.value);
            formDataObj.append("attendance_id", formData?.attendance_id);
            formDataObj.append("start_time", startDateTime.format("YYYY-MM-DD HH:mm:ss"));
            formDataObj.append("end_time", endDateTime.format("YYYY-MM-DD HH:mm:ss"));
            formDataObj.append("log_seconds", formData?.log_seconds);
            formDataObj.append("full_shift", formData?.full_shift);
            formDataObj.append("notes", formData?.notes || "");
            formDataObj.append("employee_workflow_enable_tag_asset", config.employee_workflow_enable_tag_asset);
            formDataObj.append("employee_workflow_enable_tag_ticket", config.employee_workflow_enable_tag_ticket);
            formDataObj.append("employee_workflow_enable_tag_workstation", config.employee_workflow_enable_tag_workstation);
            if (config.employee_workflow_enable_tag_asset === "Y" && formData?.asset_id) {
                formDataObj.append("asset_id", formData?.asset_id);
            }
            if (config.employee_workflow_enable_tag_ticket === "Y" && formData?.ticket_id) {
                formDataObj.append("ticket_id", formData?.ticket_id);
            }
            if (config.employee_workflow_enable_tag_workstation === "Y" && formData?.workstation_id) {
                formDataObj.append( "workstation_id",formData?.workstation_id);
            }
            const additional_attributes = {};
            if (workLogFormData?.additional_attributes?.length > 0) {
                workLogFormData.additional_attributes.forEach((attr) => {
                    const key = attr.key;
                    additional_attributes[key] =
                        formData[`additional_attributes_${key}`] || "";
                });
            }

            formDataObj.append("additional_attributes",JSON.stringify(additional_attributes));
            if (formData.showDocument && formData.photo) {
                formDataObj.append("name", formData.name);
                formDataObj.append("number", formData.number || "");
                formDataObj.append("photo", formData.photo);
            }

            requestConfig = {
                method: "POST",
                url: apiUrl,
                data: formDataObj,
                headers: {
                    Authorization: `Bearer ${access_token}`,
                    "Content-Type": "multipart/form-data",
                },
            };
        }

        api.server2Api(requestConfig)
            .then((response) => {
                modalClose();
                setFormData({ ...initFormData });

                if (props.afterSucess) { props.afterSucess() }
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT, });
            })
            .catch((error) => {
                toast.error(error.response?.data?.msg, { position: toast.POSITION.TOP_RIGHT });
            })
            .finally(() => {
                setFormData((pd) => ({
                    ...pd,
                    submitting: false,
                }));
            });
    };

    const documentHandler = () => {
         setFormData(prev => ({ 
            ...prev, 
            showDocument: !formData.showDocument,
            name: '',
            number: '',
            photo: null,
            doc_other: 'N'
        }));
    };


    return (
        <div className="modal fade" id={modalId} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {formData.isEditMode ? 'Edit Work Log' : 'Add Work Log'}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            disabled={formData.submitting || formData.loading}
                            aria-label="Close"
                        />
                    </div>
                    <div className='p-1 bg-light border-bottom'>
                        <table className='table table-sm mb-0 table-borderless text-sm'>
                            <tbody>
                                <tr>
                                    <td style={{ width: "26%" }}>Employee Name (Code)</td>
                                    <th>{employeeData?.employee?.display_full_name || "-"}</th>
                                </tr>


                                <tr>
                                    <td>Check In & Check Out</td>
                                    <th>
                                        {formData?.shift_start
                                            ? DateService.dateTimeFormat(formData.shift_start)
                                            : "-"} -  {formData?.shift_end
                                                ? DateService.dateTimeFormat(formData.shift_end)
                                                : "-"}
                                    </th>
                                </tr>
                                <tr>
                                    <td>Status</td>
                                    <th>
                                        {employeeData?.employee?.status && (
                                            <Status color={employeeData?.employee?.status_color_code}>
                                                {employeeData?.employee?.status_text}
                                            </Status>
                                        )}
                                    </th>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div className="modal-body">
                        {formData.loading ? (
                            <Loader />
                        ) : (
                                <form id={formId + 'Form'} onSubmit={submitEventHandler}>
                                    <div className="row my-2 align-items-center">
                                        <label className="col-sm-3 col-form-label col-form-label-sm require">
                                            Work Log Type
                                        </label>
                                        <div className="col-sm-7">
                                            <TapSelect
                                                options={workLogFormData?.work_log_type?.map(type => ({
                                                    value: type.id,
                                                    label: type.name
                                                })) || []}
                                                changeEvent={(selectedOption) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        work_log_type: selectedOption
                                                    }));
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                value={formData.work_log_type}
                                                placeholder="Please select Work Log Type"
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="row my-2 align-items-center">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">
                                            Duration
                                        </label>
                                        <div className="col-sm-7">
                                            <input
                                                className="form-control form-control-sm"
                                                placeholder="Duration"
                                                disabled={true}
                                                autoComplete="off"
                                                value={formData.log_seconds > 0
                                                    ? `${Math.floor(formData.log_seconds / 3600)}h ${Math.floor((formData.log_seconds % 3600) / 60)}m`
                                                    : ""}
                                            />
                                        </div>
                                        <div className='col-sm-2'>
                                            <input
                                                name="full_shift"
                                                type="checkbox"
                                                onChange={handleFullShiftToggle}
                                                className="form-check-input"
                                                id="full_Shift"
                                                checked={formData.full_shift === "Y"}
                                                disabled={!formData.shift_start || !formData.shift_end}
                                            />
                                            <label className="form-check-label mx-2" htmlFor="full_Shift">
                                                Full Shift
                                            </label>
                                        </div>
                                    </div>

                                    <div className="row my-2 align-items-center">
                                        <label className="col-sm-3 col-form-label col-form-label-sm require">
                                            Start & End Time
                                        </label>
                                        <div className="col-sm-7">
                                            <div className='row'>
                                                <div className='col-sm-6'>
                                                    <DatePicker
                                                        selected={formData?.start_time}
                                                        onChange={handleStartTimeChange}
                                                        openToDate={formData.shift_start}
                                                        showTimeSelect
                                                        timeFormat="HH:mm"
                                                        timeIntervals={5}
                                                        dateFormat="dd-MMM-yyyy HH:mm"
                                                        className="form-control form-control-sm"
                                                        placeholderText="Start Date & Time"
                                                        minDate={formData.shift_start}
                                                        maxDate={formData.shift_end}
                                                        disabled={formData.full_shift === "Y"}
                                                    />

                                                </div>
                                                <div className='col-sm-6'>
                                                    <DatePicker
                                                        selected={formData?.end_time}
                                                        onChange={handleEndTimeChange}
                                                        showTimeSelect
                                                        timeFormat="HH:mm"
                                                        timeIntervals={5}
                                                        openToDate={formData.shift_start}
                                                        dateFormat="dd-MMM-yyyy HH:mm"
                                                        className="form-control form-control-sm"
                                                        placeholderText="End Date & Time"
                                                        minDate={formData.shift_start}
                                                        maxDate={formData.shift_end}
                                                        disabled={formData.full_shift === "Y"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>   
                                    <div className="row my-2 align-items-center">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">
                                            Select Type
                                        </label>

                                        <div className="col-sm-7 d-flex gap-3">
                                            {tagOptions.map(opt => {
                                                const id = `tag-${opt.key}`;
                                                return (
                                                    <div key={opt.key} className="d-flex align-items-center">
                                                        <input
                                                            id={id}
                                                            type="radio"
                                                            name="tagType"
                                                            checked={selectedTag === opt.key}
                                                            onChange={() => {
                                                                setSelectedTag(opt.key);

                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    asset_id: opt.key === "asset" ? prev.asset_id : null,
                                                                    searchedAsset: opt.key === "asset" ? prev.searchedAsset : null,

                                                                    workstation_id: opt.key === "workstation" ? prev.workstation_id : null,
                                                                    searchedWorkstation: opt.key === "workstation" ? prev.searchedWorkstation : null,
                                                                }));
                                                            }}
                                                        />
                                                        <label htmlFor={id} className="ms-1 cursor-pointer">
                                                            {opt.label}
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    {selectedTag === "asset" && (
                                        <div className="row my-2 align-items-center">
                                            <label className="col-sm-3 col-form-label col-form-label-sm">
                                                Asset
                                            </label>
                                            <div className="col-sm-7">
                                                <InputAssetSearch
                                                    changeEvent={(selectedOption) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            asset_id: selectedOption?.value || null,
                                                            searchedAsset: selectedOption || null,
                                                            workstation_id: null,
                                                            searchedWorkstation: null
                                                        }));
                                                    }}
                                                    value={formData.searchedAsset ? { ...formData.searchedAsset, label: formData.searchedAsset.display_label } : null}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {selectedTag === "workstation" && (
                                        <div className="row my-2 align-items-center">
                                            <label className="col-sm-3 col-form-label col-form-label-sm">
                                                Workstation
                                            </label>
                                            <div className="col-sm-7">
                                                <InputWorkstationSearch
                                                    placeholder="Please Select Workstation"
                                                    changeEvent={(selectedOption) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            workstation_id: selectedOption?.value || null,
                                                            searchedWorkstation: selectedOption || null,
                                                            asset_id: null,
                                                            searchedAsset: null
                                                        }));
                                                    }}
                                                    menuPlacement="top"
                                                    value={formData.searchedWorkstation}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {config.employee_workflow_enable_tag_ticket === 'Y' && (
                                        <div className="row my-2 align-items-center">
                                            <label className="col-sm-3 col-form-label col-form-label-sm">
                                                Ticket
                                            </label>
                                            <div className="col-sm-7">
                                                <InputTicketSearch
                                                    changeEvent={(selectedOption) => {


                                                        if (!selectedOption) {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                ticket_id: null,
                                                                searchedTicket: null
                                                            }));
                                                            return;
                                                        }
                                                        
                                                        const ticketData = selectedOption;
                                                        
                                                        setFormData(prev => {
                                                            let updatedData = {
                                                                ...prev,
                                                                ticket_id: ticketData?.value || null,
                                                                searchedTicket: ticketData
                                                            };
                                                            
                                                            if (prev.asset_id) {
                                                                updatedData.workstation_id = null;
                                                                updatedData.searchedWorkstation = null;
                                                                return updatedData;
                                                            }
                                                            if (prev.workstation_id) {
                                                                updatedData.asset_id = null;
                                                                updatedData.searchedAsset = null;
                                                                return updatedData;
                                                            }
                                                            
                                                            if (ticketData?.asset?.asset_id) {
                                                                updatedData.asset_id = ticketData.asset.asset_id;
                                                                updatedData.searchedAsset = {
                                                                    value: ticketData.asset.asset_id,
                                                                    label: ticketData.asset.name,
                                                                    display_label: `${ticketData.asset.name} (${ticketData.asset.asset_code})`
                                                                };

                                                                updatedData.workstation_id = null;
                                                                updatedData.searchedWorkstation = null;

                                                                setSelectedTag("asset");
                                                            }
                                                            else if (ticketData?.data?.workStation?.id) {
                                                                updatedData.workstation_id = ticketData?.data?.workStation?.id;
                                                                updatedData.searchedWorkstation = {
                                                                    value: ticketData?.data?.workStation?.id,
                                                                    label: ticketData?.data?.workStation?.name
                                                                };

                                                                updatedData.asset_id = null;
                                                                updatedData.searchedAsset = null;
                                                                
                                                                setSelectedTag("workstation");
                                                            }
                                                           
                                                            return updatedData;
                                                        })

                                                    }}
                                                    value={formData.searchedTicket}
                                                    search_asset_id = {formData.asset_id}
                                                    search_workstation = {formData.workstation_id}

/>
                                            </div>
                                        </div>
                                    )
                                    }
                                    {workLogFormData?.additional_attributes?.length > 0 && (
                                        <AdditionalAttributeForm
                                            additionalAttributes={workLogFormData.additional_attributes}
                                            formState={formData}
                                            onAttributeChange={handleAttributeChange}
                                            colSpan="col-sm-7"
                                        />
                                    )}
                                    
                                    <div className="row my-2 align-items-center">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">
                                            Notes
                                        </label>
                                        <div className="col-sm-7">
                                            <textarea
                                                className="form-control form-control-sm"
                                                rows="3"
                                                value={formData.notes || ''}
                                                onChange={(e) => setFormData(prev => ({
                                                    ...prev,
                                                    notes: e.target.value
                                                }))}
                                                placeholder="Enter Notes"
                                            />
                                        </div>
                                    </div>
                                    
                                    {permissions.includes('emp_worklog_doc_add') && !formData.isEditMode && <div className="d-flex text-end justify-content-end align-items-end me-3 mt-2">
                                        <span className="cursor_pointer text-primary" onClick={documentHandler}>
                                            + Add Document
                                        </span>
                                    </div>}
                                    {formData.showDocument && (
                                        <div className=" mt-3">
                                            <div className="row align-items-center mb-3">
                                                <div className="col-md-3">
                                                    <label className="col-form-label col-form-label-sm require">Document Type</label>
                                                </div>
                                                <div className="col-sm-7">
                                                    {formData.doc_other === "Y"
                                                        ? <input
                                                            name="name"
                                                            type="text"
                                                            value={formData.name}
                                                            className="form-control "
                                                            autoComplete="off"
                                                            onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                                                            placeholder="Please enter Type Name"
                                                            required={true}
                                                        />
                                                        : <TapSelect
                                                            options={documentTypes}
                                                            changeEvent={(selectedOption) =>
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    name: selectedOption ? selectedOption.value : ''
                                                                }))
                                                            }
                                                            value={documentTypes.find(
                                                                option => option.value === formData.name
                                                            )}
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            placeholder="Select Document Type"
                                                            autoComplete="off"
                                                            required={true}
                                                            menuPlacement={"top"}
                                                            autoFocus={true}
                                                        />
                                                    }
                                                </div>
                                                <div className="col-sm-2">
                                                    <input
                                                        name="doc_other"
                                                        type="checkbox"
                                                        checked={formData.doc_other === 'Y'}
                                                        onChange={() => {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                doc_other: prev.doc_other === 'N' ? 'Y' : 'N',
                                                                name: ''
                                                            }));
                                                        }}
                                                        className="form-check-input"
                                                        id="otherDoc"
                                                    />
                                                    <label className="form-check-label mx-2" htmlFor="otherDoc">New</label>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-sm-3">
                                                    <label className="col-form-label col-form-label-sm">Document Number</label>
                                                </div>
                                                <div className="col-md-7">
                                                    <input
                                                        name="number"
                                                        type="text"
                                                        value={formData.number}
                                                        onChange={(e) => setFormData(prev => ({ ...prev, number: e.target.value }))}
                                                        className="form-control "
                                                        autoComplete="off"
                                                        placeholder="Enter Document Number"
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-3">
                                                    <label className="col-form-label col-form-label-sm require">Document</label>
                                                </div>
                                                <div className="col-md-7">
                                                    <input
                                                        name="photo"
                                                        type="file"
                                                        onChange={handleFileChange}
                                                        className="form-control form-control-sm"
                                                        autoComplete="off"
                                                        required={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </form>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            disabled={formData.submitting || formData.loading}
                            data-bs-dismiss="modal"
                        >
                            Close
                        </button>
                        <button
                            form={formId + 'Form'}
                            type="submit"
                            disabled={formData.submitting || formData.loading || !formData.work_log_type}
                            className="btn btn-primary"
                        >
                            Save {formData.submitting && (
                                <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default WorkLogModal;


